import React from "react";
import Top from "../../Top";
import Left from "../../Left";
// import { useNavigate } from "react-router-dom";
import { Grid } from "@mui/material";

function Payments() {
  // const navigate = useNavigate();

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Payments</h1>
            {/* <Button
              className="contentTopLefBt"
                onClick={handleClickOpen("body")}
            >
              Download
            </Button> */}
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default Payments;
